/* eslint-disable react/prop-types */
import { Field, Label, Switch } from '@headlessui/react'
import { classNames } from './utils'

export default function Toggle({ label, value, onChange, size, isReverse = false, disabled = false }) {
    const enabled = value
    const setEnabled = onChange
    return (
        <Field className={classNames(isReverse ? 'flex items-center w-full justify-between' : 'flex items-center ')}>
            {isReverse && (
                <Label as='div' className={classNames(size ? size : 'text-sm', 'mr-3')}>
                    <span className='font-normal text-gray-600'>{label}</span>
                </Label>
            )}
            <Switch
                checked={enabled}
                onChange={setEnabled}
                className={classNames(
                    size ? 'h-2 w-5 ' : 'h-3 w-8 ',
                    'group relative inline-flex flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none '
                )}
                disabled={disabled}
            >
                <span
                    aria-hidden='true'
                    className={classNames(
                        size ? 'h-2 w-3' : 'h-3 w-7  ',
                        'pointer-events-none absolute mx-auto rounded-full bg-gray-200 transition-colors duration-200 ease-in-out group-data-[checked]:bg-mtmain'
                    )}
                />
                <span
                    aria-hidden='true'
                    className={classNames(
                        size ? 'h-3 w-3' : 'h-4 w-4  ',
                        'pointer-events-none absolute left-0 inline-block transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out group-data-[checked]:translate-x-4'
                    )}
                />
            </Switch>
            {!isReverse && typeof label === 'string' ? (
                <Label as='span' className={classNames(size ? size : 'text-sm', 'ml-3')}>
                    <span className='font-normal text-gray-600'>{label}</span>
                </Label>
            ) : !isReverse && typeof label !== 'string' ? (
                label
            ) : null}
        </Field>
    )
}
